<div style="display:flex;align-items:center;padding:6px 10px 0;min-width:0;position:sticky;top:0;z-index:10;background:var(--py-arkaplan,#fff);">
  <button class="ui basic mini icon button" style="margin-right:8px;flex-shrink:0;" (click)="geriTiklandi()">
    <i class="arrow left icon"></i>
  </button>
  <nz-divider nzText="🛒 Satış"
              nzOrientation="center"
              style="margin:0;flex:1;min-width:0;overflow:hidden;"
              nzSize="small"></nz-divider>
  <button class="ui basic mini icon button" style="margin-left:8px;flex-shrink:0;" (click)="listeIstek.isteSync()">
    <i class="redo icon"></i>
  </button>
</div>

<div class="projeler-icerik">
  <fikoyt-paylas-kutusu [kart]="hmiSvc.kart"
                        [parametreSetleri]="hmiSvc.parametreSetleri"
                        [parametreSetiZorunlu]="true"
                        [taslakDevreDisi]="true"
                        (paylasimYapildi)="paylasimYapildi()"></fikoyt-paylas-kutusu>

  <div style="max-width: 520px; width: 100%; margin-bottom: 8px;">
    <fikoyt-fiko-filitreci [(sablon)]="filitreciSablon"
                           [parametreModu]="true"
                           [temelAlanlarEkle]="true"
                           [kartParametreleri]="tumParametreler"
                           [bilesenTipleri]="bilesenTipleri"
                           [dinamikBilesenSetleri]="dinamikBilesenSetleri"
                           [siralamalar]="siralamalar"
                           [siralama]="aktifSiralama"
                           (siralamaDegisti)="siralamaDegisti($event)"
                           (enterBasildi)="filtreUygula()"
                           (uygulaBasildi)="filtreUygula()"
                           (temizleBasildi)="filtreTemizle()">
    </fikoyt-fiko-filitreci>
  </div>

  @if (listeIstek.mesgul) {
    <div style="text-align:center;padding:24px 0;">
      <nz-spin nzSimple></nz-spin>
    </div>
  } @else if (listeIstek.liste.length < 1) {
    <div class="bos-proje-kart">
      <div class="bos-proje-serit"></div>
      <div class="bos-proje-daire d1"></div>
      <div class="bos-proje-daire d2"></div>
      <div style="font-size:42px;margin-bottom:10px;">🛒</div>
      <div class="bos-proje-baslik">Henüz Kayıt Yok</div>
      <div class="bos-proje-aciklama">
        Yukarıdan bir şablon seçerek ilk kaydınızı oluşturun.<br>
        Siparişler, teklifler ve müşteri bilgileri burada görünecek.
      </div>
      <div style="display:flex;justify-content:center;gap:6px;margin-top:14px;">
        <span class="bos-proje-dot" style="width:24px;"></span>
        <span class="bos-proje-dot" style="width:12px;opacity:0.6;"></span>
        <span class="bos-proje-dot" style="width:8px;opacity:0.4;"></span>
      </div>
    </div>
  } @else {
    @for (k of listeIstek.liste; track k._id) {
      <fikoyt-kart-kok [kart]="k" [kartParametreSetleri]="hmiSvc.parametreSetleri"
                       (kartGuncellendi)="listeIstek.liste[$index] = $event; listeIstek.liste = listeIstek.liste.slice(); CD.detectChanges()"></fikoyt-kart-kok>
    }
  }
</div>
